export default {
  'cart.title': '장바구니',
  'cart.breadcrumb.home': 'Home',
  'cart.totalCount': '총 {{count}}건 / {{quantity}}개 상품',
  'cart.emptyCart': '전체 비우기',
  'cart.emptyTitle': '장바구니가 비어있습니다',
  'cart.emptyDesc': '마음에 드는 상품을 장바구니에 담고 한 번에 견적을 요청해보세요.',
  'cart.browseProducts': '상품 둘러보기',
  'cart.selectAll': '전체선택 ({{selected}}/{{total}})',
  'cart.deleteSelected': '선택삭제',
  'cart.unitPrice': '단가',
  'cart.quoteInquiry': '견적 문의',
  'cart.amount': '금액',
  'cart.totalAmount': '총 합계금액',
  'cart.totalUnits': '(총 {{count}}개)',
  'cart.continueShopping': '계속 쇼핑하기',
  'cart.checkout': '주문하기',
  'cart.remove': '삭제',
  'cart.toastSelectItem': '주문할 상품을 선택해주세요',
};